export const routes = {
  root: '/',
  phonebooth: {
    home: '/home/*',
    status: '/status/*',
  },
};
